module.exports = __webpack_public_path__ + "img/login-bottom.a214b921.png";